import { SortableFilter }          from '../common/sortable-filter';

export class HolidayExceptionSortableFilter extends SortableFilter {
    public exceptionDateObj: Date;
    public exceptionDate: string;
    public trainUid: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/holiday-exception-list/holiday-exception-filter.ts